export default "__VITE_ASSET__BBs6qeik__"